import axiosInstance from '../../../../../utils/axios';
import { RfxSyncStatusResponse } from './models';
import { RfxSyncStatusError } from './errors';

const getRfxSyncStatus = async (token: string): Promise<RfxSyncStatusResponse> => {
  try {
    const response = await axiosInstance.get<RfxSyncStatusResponse>(
      '/rfx-linking/status',
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      },
    );
    return response.data;
  } catch (error: any) {
    if (error.response) {
      throw new RfxSyncStatusError(error.response.data?.status || 'UNKNOWN_ERROR');
    }
    throw new RfxSyncStatusError('UNKNOWN_ERROR');
  }
};

export default getRfxSyncStatus;
